export default "__VITE_ASSET__l4K6mVs8__"